import React,{Component} from 'react';
import './notification.css';
import './Form/form.css';
import CancelForm from './Form/CancelForm';
import {Helmet} from "react-helmet";

export default class NotificationCancel extends Component{
  constructor(props){
    super();
	}

  renderForm(){
      return <CancelForm />;
  }

  render(){
    return(
      <div className="page full">
      <Helmet>
          <meta charSet="utf-8" />
          <title>{this.props.pageTitle}</title>
          <link rel="canonical" href={this.props.pageCanonicalLink} />
          <meta name="description" content={this.props.pageDescription} />
      </Helmet>
          <div className="title">
            <h3>  </h3>
          </div>
          <div className="form-title">
            <h4> Transaction annulée </h4>
          </div>
          {this.renderForm()}

      </div>
    )
  }
}
